import type { FC } from "react";
import { useSelector } from "react-redux";
import { useLineups } from "../../../../../../hooks/use-lineups";
import { selectFixtureId } from "../../../../../../redux/broadcast/broadcast.selectors";
import MentionMenu from "./mentions/mention-menu";
import { useMentionAutocomplete } from "./mentions/use-mention-autocomplete";
import * as CSS from "./updates-textarea.styles";

type UpdatesTextAreaProps = {
	value: string;
	onChange: (value: string) => void;
	onSubmit: () => void;
	rows?: number;
};

const UpdatesTextArea: FC<UpdatesTextAreaProps> = ({
	onChange,
	onSubmit,
	value,
	rows = 5,
}) => {
	const fixtureId = useSelector(selectFixtureId);
	const lineups = useLineups(fixtureId);

	const mention = useMentionAutocomplete({ value, onChange, lineups });

	const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
		if (mention.handleKeyDown(e)) return;

		if (e.key === "Enter") {
			e.preventDefault();
			onSubmit();
			return;
		}
	};

	return (
		<CSS.Wrapper>
			<CSS.UpdatesTextarea
				ref={mention.textareaRef}
				rows={rows}
				placeholder="Type @ to mention a player or team"
				value={value}
				onChange={mention.handleChange}
				onSelect={mention.handleSelectionChange}
				onClick={mention.handleSelectionChange}
				onKeyDown={handleKeyDown}
			/>
			{mention.isOpen && mention.position && (
				<MentionMenu
					sections={mention.sections}
					selectedIndex={mention.selectedIndex}
					position={mention.position}
					onHover={mention.selectIndex}
					onSelect={(index) => {
						const item = mention.flatItems[index];
						if (item) mention.confirm(item);
					}}
				/>
			)}
		</CSS.Wrapper>
	);
};

export default UpdatesTextArea;
